import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64de8a14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nologin-service-sp d-md-none" }
const _hoisted_2 = { class: "mxa-nologin-service-sp-content" }
const _hoisted_3 = {
  class: "mxa-nologin-service-pc d-none d-md-block",
  "data-test": "md"
}
const _hoisted_4 = { class: "mxa-nologin-service-pc-title" }
const _hoisted_5 = { class: "mxa-nologin-service-pc-content" }

import BaseAccordion from '@/components/common/parts/BaseAccordion.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginTopService',
  setup(__props) {

const messages = [
  'body.top.service.message0',
  'body.top.service.message1',
  'body.top.service.message2',
  'body.top.service.message3',
  'body.top.service.message4',
  'body.top.service.message5',
  'body.top.service.message6',
  'body.top.service.message7',
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BaseAccordion, {
        accordionId: "topService",
        headerTitle: _ctx.$t('body.top.service.title'),
        "data-test": "sm"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(messages, (value, index) => {
              return _createElementVNode("div", { key: index }, _toDisplayString(_ctx.$t(value)), 1)
            }), 64))
          ])
        ]),
        _: 1
      }, 8, ["headerTitle"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('body.top.service.title')), 1),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(messages, (value, index) => {
          return _createElementVNode("div", { key: index }, _toDisplayString(_ctx.$t(value)), 1)
        }), 64))
      ])
    ])
  ], 64))
}
}

})